import { isServer } from 'solid-js/web';
import { baseNetworkManager } from '~/gateways/network/baseNetworkManager';
import { MagicRequest } from '~/gateways/network/magicRequest';
import { NetworkManager } from '~/gateways/network/networkManager';
import { renderContext } from '~/platform/renderContext';

export interface RenderingHost {
  isServer: boolean;
  isDev: boolean;
  pageUrl: () => string | undefined;
}

export class FullStackNetworkManager implements NetworkManager {
  constructor(
    private readonly networkManager: NetworkManager,
    private readonly host: RenderingHost
  ) {}

  public sendRequest = async (request: MagicRequest): Promise<Response> => {
    return this.networkManager.sendRequest({ ...request, url: this.addressOf(request.url) });
  };

  private addressOf(uri: string): string {
    if (!this.host.isServer) {
      return uri;
    }
    if (this.host.isDev) {
      const pageUrl = this.host.pageUrl();
      return pageUrl ? new URL(uri, pageUrl).toString() : uri;
    }
    return `http://portal-backend${uri.replace(/^\/api/, '/company-web')}`;
  }
}

export const fullStackNetworkManager = new FullStackNetworkManager(baseNetworkManager, {
  isServer,
  isDev: import.meta.env.DEV,
  pageUrl: renderContext.pageUrl,
});
